import { ConfigContext } from "../context/CLPConfigContext"
import { useContext } from "react"

export const useConfig = () => {
  const context = useContext(ConfigContext)
  if (context === null || context === undefined) {
    console.warn("ConfigContext is null or undefined")
    return {}
  }

  return context
}
